import '../style.scss';

const KATAKANA_LIST = [
  ['ア', 'カ', 'サ', 'タ', 'ナ', 'ハ', 'マ', 'ヤ', 'ラ', 'ワ'],
  ['イ', 'キ', 'シ', 'チ', 'ニ', 'ヒ', 'ミ', '', 'リ', ''],
  ['ウ', 'ク', 'ス', 'ツ', 'ヌ', 'フ', 'ム', 'ユ', 'ル', 'ヲ'],
  ['エ', 'ケ', 'セ', 'テ', 'ネ', 'ヘ', 'メ', '', 'レ', ''],
  ['オ', 'コ', 'ソ', 'ト', 'ノ', 'ホ', 'モ', 'ヨ', 'ロ', 'ン'],
];

type BankSearchGojuonProps = {
  label: string;
  onClick: (kana: string) => void;
};

/**
 * 50音検索
 * @param props
 * @returns
 */
export const BankSearchGojuon = (props: BankSearchGojuonProps) => {
  const { label, onClick } = props;

  return (
    <div className="GojuonSearchWrapper">
      <div className="GojuonSearchLabel">{label}</div>
      <div className="kanaSelect">
        {KATAKANA_LIST.map((column, index) => (
          <div key={index} className="kanaRow">
            {column.map((kana, index) => (
              <KanaCell key={index} kana={kana} onClick={(kana) => onClick(kana)} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

type KanaCellProps = {
  kana: string;
  onClick: (value: string) => void;
};

const KanaCell = (props: KanaCellProps) => {
  const { kana, onClick } = props;
  return (
    <div className="kanaCell" onClick={kana ? () => onClick(kana) : undefined}>
      {kana}
    </div>
  );
};
